export const markupParser = text => {
  text = text.trim();
  text = text.replace(/`/g, '');
  const lines = text.split('\n');
  const html = [];
  let listOpen = false;
  let olOpen = false;
  const isSectionHeader = line => /^[A-Z ]{3,}$/.test(line.trim()) && !line.includes(':');
  for (let line of lines) {
    line = line.trim();
    if (line === '') {
      if (listOpen) {
        html.push('</ul>');
        listOpen = false;
      }
      if (olOpen) {
        html.push('</ul>');
        olOpen = false;
      }
      continue;
    }
    if (isSectionHeader(line)) {
      html.push(`<h2>${line.replace(/^#+\s*/, '')}</h2>`);
    } else if (line.startsWith('### ')) {
      html.push(`<h3>${line.slice(4)}</h3>`);
    } else if (line.startsWith('#### ')) {
      html.push(`<h4>${line.slice(5)}</h4>`);
    } else if (/^\d+\.\s+/.test(line)) {
      if (!olOpen) {
        html.push('<ul>');
        olOpen = true;
      }
      line = line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
      html.push(`<li>${line.replace(/^\d+\.\s+/, '')}</li>`);
    } else if (line.startsWith('- ')) {
      if (!listOpen) {
        html.push('<ul>');
        listOpen = true;
      }
      line = line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
      html.push(`<li>${line.slice(2)}</li>`);
    } else {
      line = line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
      html.push(`<p>${line}</p>`);
    }
  }
  if (listOpen) html.push('</ul>');
  if (olOpen) html.push('</ul>');
  return html.join('\n');
};
export default markupParser;